module.exports = __webpack_public_path__ + "static/media/nlogn.f777981a.jpg";